'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';

const StatusBarChangelog = () => {
  return /*#__PURE__*/_jsxs(UILink, {
    className: "status-bar-header-button-long",
    href: "https://developers.hubspot.com/changelog",
    target: "_blank",
    external: true,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "blog"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "DesignEditorsUI.statusBar.header.changelog"
    })]
  });
};

export default StatusBarChangelog;